import firebase from '../../firebase/firebaseConfig';
import {
    onFirebaseCreateAccountFailedHandler,
    onFirebaseLoginFailedHandler,
} from '../../utils/failHandlers';
import userService from '../../database/userService';
import {startLoading, stopLoading} from './ui';
import {AUTH_SET_USER_DETAILS} from './actionTypes';
import {mapEntityFromDoc} from '../../utils/firebase';

export const tryAuthWithEmail = (
    authData,
    onAuthSuccess,
    onAuthFail,
) => async dispatch => {
    authFunction(authData, onAuthSuccess, onAuthFail, dispatch);
};

export const tryCreateAccount = (
    authData,
    onAuthSuccess,
    onAuthFail,
) => async dispatch => {
    createAccountFunction(authData, onAuthSuccess, onAuthFail, dispatch);
};

const authFunction = async (authData, onAuthSuccess, onAuthFail, dispatch) => {
    dispatch(startLoading());
    try {
        const authResult = await firebase
            .auth()
            .signInWithEmailAndPassword(authData.email, authData.password);
        await handleFetchAndSetUserData(authResult, onAuthSuccess, dispatch);
    } catch (error) {
        dispatch(stopLoading());
        console.error(error);
        onFirebaseLoginFailedHandler(error.code, onAuthFail);
    }
};

const handleFetchAndSetUserData = async (
    authResult,
    onAuthSuccess,
    dispatch,
) => {
    try {
        await createOrFetchUserDoc(authResult, dispatch);
        dispatch(stopLoading());
        onAuthSuccess();
    } catch (error) {
        console.error(error);
    }
};

const fetchAndStoreUserDetails = async (userId, dispatch) => {
    const userDoc = await userService.getById(userId);
    dispatch(authSetUserDetails(mapEntityFromDoc(userDoc)));
};

const createOrFetchUserDoc = async (authResult, dispatch) => {
    const {email, uid} = authResult.user;
    if (authResult.additionalUserInfo.isNewUser) {
        await userService.create(uid, {email});
    }
    await fetchAndStoreUserDetails(uid, dispatch);
};

const createAccountFunction = async (
    authData,
    onAuthFail,
    onAuthSuccess,
    dispatch,
) => {
    dispatch(startLoading());
    try {
        const result = await firebase
            .auth()
            .createUserWithEmailAndPassword(authData.email, authData.password);
        await handleFetchAndSetUserData(result, onAuthSuccess, dispatch);
    } catch (error) {
        dispatch(stopLoading());
        console.error(error);
        onFirebaseCreateAccountFailedHandler(error.code, onAuthFail);
    }
};

export const authSetUserDetails = userDetails => ({
    type: AUTH_SET_USER_DETAILS,
    userDetails,
});
